import { render, staticRenderFns } from "./LayoutsList.vue?vue&type=template&id=31968e82&scoped=true"
import script from "./LayoutsList.vue?vue&type=script&lang=js"
export * from "./LayoutsList.vue?vue&type=script&lang=js"
import style0 from "./LayoutsList.vue?vue&type=style&index=0&id=31968e82&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31968e82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31968e82')) {
      api.createRecord('31968e82', component.options)
    } else {
      api.reload('31968e82', component.options)
    }
    module.hot.accept("./LayoutsList.vue?vue&type=template&id=31968e82&scoped=true", function () {
      api.rerender('31968e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/LayoutsList.vue"
export default component.exports